{
  "pt": {
    "select": {
      "actions": {
        "clear": "Limpar",
        "filterProject": "Filtro no projeto",
        "filterUnit": "Filtro na unidade",
        "noResults": "Sem resultados",
        "noResultsFor": "Nenhum resultado para {search}",
        "reset": "Reiniciar",
        "selectCategory": "Selecionar categoria",
        "selectUnit": "Selecionar unidade",
        "setToday": "Hoje",
        "startTyping": "Começar a escrever para pesquisar"
      },
      "groups": {
        "customers": "Clientes",
        "employees": "Membros da equipa"
      },
      "labels": {
        "allUnits": "Todas as unidades",
        "contact": "Contacto",
        "without": "Sem",
        "withoutContact": "Sem pessoa de contacto"
      },
      "placeholders": {
        "contact": "Procure uma pessoa, ou escolha 'sem'..."
      }
    }
  }
}
